export enum ProjectStatusEnum {
  PLANNED = "Planned",
  APPROVED = "Approved",
  PENDING_PERMIT = "Pending Permit",
  OCCUPANCY_IN_PROGRESS = "Occupancy in progress",
  COMPLETE = "Complete",
  /** @deprecated Legacy status retained for older imports */
  PLANNING = "Planning",
  CANCELED = "Canceled",
}

export enum ProjectSourceEnum {
  MANUAL = "manual",
  IMPORT = "import",
  SHOVELS = "shovels",
}

export enum ProjectReviewStatusEnum {
  DRAFT = "draft",
  READY_FOR_REVIEW = "ready_for_review",
  PUBLISHED = "published",
  REJECTED = "rejected",
}

export const VISIBLE_PROJECT_REVIEW_STATUSES = [
  ProjectReviewStatusEnum.PUBLISHED,
  ProjectReviewStatusEnum.READY_FOR_REVIEW,
  ProjectReviewStatusEnum.DRAFT,
] as const;

export const PROJECT_STATUS_WRITE_OPTIONS = [
  ProjectStatusEnum.PLANNED,
  ProjectStatusEnum.APPROVED,
  ProjectStatusEnum.PENDING_PERMIT,
  ProjectStatusEnum.OCCUPANCY_IN_PROGRESS,
  ProjectStatusEnum.COMPLETE,
  ProjectStatusEnum.CANCELED,
] as const;

export type ProjectSchoolType = "ELEMENTARY" | "MIDDLE" | "HIGH" | "K8";
